export default "__VITE_ASSET__BxLqhqBR__"